module.exports = "<button (click)=\"login()\" class=\"btn btn-primary\">Login with Google</button>"


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main